const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.RUNNING = 1;
GameStatus.FINISH = 2;
GameStatus.END = 3;
GameStatus.TUTORIAL = 4;

export default GameStatus;